export interface IRoundPayment {
  coupon: any;
  items: {
    registeredPlayers: number;
    freeTrials: number;
  };
  subtotalPrice: number;
  totalPrice: number;
}

export interface IRoundPaymentsStore {
  [roundId: number]: IRoundPayment;
}

export const roundPaymentsStore: IRoundPaymentsStore = {};
